'use client';

import { useEffect } from 'react';
import { type PageType, registerClientProfilerPage } from '@/src/lib/clientProfiler';

export function ClientProfilerRegistrar({ pageType }: { pageType: PageType }) {
  useEffect(() => {
    return registerClientProfilerPage(pageType);
  }, [pageType]);

  return null;
}
